import Handlebars from 'handlebars';
import moment from 'moment';
import { unescape } from 'lodash-es';

const DATE_FORMAT = 'YYYY-MM-DD';
const DATE_FORMAT_DISPLAY = 'DD MMM, YYYY';

// register helper functions
Handlebars.registerHelper('makeBold', (name) => `<strong>${name}</strong>`);

Handlebars.registerHelper('currentDate', () => moment().format(DATE_FORMAT));

Handlebars.registerHelper('formatDate', (value, dtf = DATE_FORMAT_DISPLAY) => {
  const dateValue = moment(value, DATE_FORMAT);
  if (!dateValue.isValid()) return moment().format(dtf);
  return dateValue.format(dtf);
});

Handlebars.registerHelper('compareDate', (value, compareWith, operator = 'equals') => {
  let result = false;
  const dateValue = resetTimeParams(moment(value, DATE_FORMAT));
  const compareWithValue = resetTimeParams(moment(compareWith, DATE_FORMAT));
  switch (operator) {
    case 'equals': result = dateValue.diff(compareWithValue, 'day') === 0; break;
    case 'greaterThan': result = dateValue.isAfter(compareWithValue); break;
    case 'lessThan': result = dateValue.isBefore(compareWithValue); break;
    case 'greaterThanEquals': result = (dateValue.isAfter(compareWithValue) || dateValue.diff(compareWithValue, 'day') === 0); break;
    case 'lessThanEquals': result = (dateValue.isBefore(compareWithValue) || dateValue.diff(compareWithValue, 'day') === 0); break;
    default: result = dateValue.diff(compareWithValue, 'day') === 0; break;
  }
  return result;
});

// util functions
const resetTimeParams = (date) => date.hours(0).minutes(0).seconds(0).milliseconds(0);

const replaceBraces = (str) => str
  .replace(new RegExp('<%', 'g'), '{{')
  .replace(new RegExp('%>', 'g'), '}}');

// format and compile template
const compileMessage = (template, context = {}) => {
  try {
    const compiledTemplate = Handlebars.compile(replaceBraces(template));
    return unescape(compiledTemplate(context));
  }
  catch(err) {
    const error = `[TemplateHandler util function] Error in template parsing: ${err}`;
    console.error(error);
    return error;
  }
};

export default compileMessage;
